// src/components/Footer.js

import React from 'react';
import '../styles/Footer.css'; // Import the CSS

const Footer = () => {
  return (
    <footer className="footer-container">
      <p>© 2023 Webflix. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
